import { createFileRoute } from "@tanstack/react-router";
import { ElisaContainer } from "../../app/views/elisa/elisaContainer";

export const Route = createFileRoute("/elisa")({
  component: ElisaContainer,
});
